import React from 'react';
import { observer } from 'mobx-react';
import { deliveryZonesStore } from '~/mobx';
import { Polygon } from '~/view/components/Map2/Polygon/Polygon';

const DeliveryZonesMapAreas = () => {
  // While a brand-new zone is being actively drawn (same condition as `shouldDraw` in
  // DeiveryZoneDrawingTools), existing zones must not intercept mouse events: they're
  // clickable, filled (fillOpacity 0.4) polygons rendered at a very high z-index (see
  // Map2/Polygon/Polygon.tsx), so hovering over one routes mousemove/mouseout to that
  // polygon instead of the map object — which silently kills the rubber-band line that's
  // supposed to follow the cursor while drawing (map-level 'mousemove' just stops firing
  // for as long as the cursor is over an existing zone, and doesn't reliably resume
  // afterward). Disabling clickability only during this window keeps zones visible for
  // context, restores it once drawing ends, and doesn't affect selecting an existing zone
  // at any other time.
  const isDrawingNewZone = Boolean(deliveryZonesStore.draft) && !deliveryZonesStore.draft?.bounds.length;

  return (
    <>
      {deliveryZonesStore.pagination.data
        .filter(
          (zone) =>
            zone.id !== deliveryZonesStore.draft?.id &&
            (!deliveryZonesStore.filters.search || zone.name.toLocaleLowerCase().includes(deliveryZonesStore.filters.search.toLocaleLowerCase())),
        )
        .reverse()
        .map((zone, index) => (
          <Polygon
            index={index}
            clickable={!isDrawingNewZone}
            onClick={() => {
              deliveryZonesStore.selectZone(zone);
            }}
            color={deliveryZonesStore.getColor(zone)}
            paths={zone.bounds}
          />
        ))}
    </>
  );
};

export default observer(DeliveryZonesMapAreas);
